export const DISPLAY_FLEX = "flex";
export const DISPLAY_BLOCK = "block";
export const DISPLAY_INLINE = "inline";
export const DISPLAY_INLINE_FLEX = "inline-flex";
export const DISPLAY_INLINE_BLOCK = "inline-block";
export const DISPLAY_GRID = "grid";
export const DISPLAY_NONE = "none";
export const POSITION_RELATIVE = "relative";
export const POSITION_ABSOLUTE = "absolute";
export const POSITION_FIXED = "fixed";
export const POSITION_STICKY = "sticky";
export const POSITION_STATIC = "static";
export const FLEX_DIRECTION_ROW = "row";
export const FLEX_DIRECTION_COLUMN = "column";
export const FLEX_DIRECTION_ROW_REVERSE = "row-reverse";
export const FLEX_DIRECTION_COLUMN_REVERSE = "column-reverse";
export const FLEX_WRAP_NOWRAP = "nowrap";
export const FLEX_WRAP_WRAP = "wrap";
export const FLEX_ALIGN_START = "flex-start";
export const FLEX_ALIGN_END = "flex-end";
export const FLEX_ALIGN_CENTER = "center";
export const FLEX_ALIGN_BASELINE = "baseline";
export const FLEX_ALIGN_STRETCH = "stretch";
export const FLEX_JUSTIFY_START = "flex-start";
export const FLEX_JUSTIFY_END = "flex-end";
export const FLEX_JUSTIFY_CENTER = "center";
export const FLEX_JUSTIFY_SPACE_BETWEEN = "space-between";
export const FLEX_JUSTIFY_SPACE_AROUND = "space-around";
export const FLEX_JUSTIFY_SPACE_EVENLY = "space-evenly";
export const FLEX_GROW = "1";
export const FLEX_SHRINK = "0";
export const FLEX_BASIS_AUTO = "auto";
export const FLEX_BASIS_CONTENT = "content";
export const MAX_WIDTH = "100%";
export const HALF_WIDTH = "50%";
export const QUARTER_WIDTH = "25%";
export const WIDTH_FIT_CONTENT = "fit-content";
export const FULL_HEIGHT = "100vh";
export const TEXT_ALIGN_LEFT = "left";
export const TEXT_ALIGN_RIGHT = "right";
export const TEXT_ALIGN_CENTER = "center";

export const FONT_SIZE_XXS = "8px";
export const FONT_SIZE_XS = "10px";
export const FONT_SIZE_SM = "12px";
export const FONT_SIZE_MD = "14px";
export const FONT_SIZE_LG = "16px";
export const FONT_SIZE_XL = "20px";
export const FONT_SIZE_XXL = "24px";
export const FONT_SIZE_XXXL = "48px";
export const FONT_SIZE_CUSTOM = "72px";
export const FONT_SIZE_CUSTOM_XL = "64px";
export const FONT_SIZE_CUSTOM_LG = "18px";

export const FONT_WEIGHT_LIGHT = "300";
export const FONT_WEIGHT_NORMAL = "400";
export const FONT_WEIGHT_MEDIUM = "500";
export const FONT_WEIGHT_BOLD = "600";
export const FONT_WEIGHT_EXTRA_BOLD = "700";

export const LINE_HEIGHT_XXS = "8px";
export const LINE_HEIGHT_XS = "12px";
export const LINE_HEIGHT_SM = "16px";
export const LINE_HEIGHT_MD = "20px";
export const LINE_HEIGHT_LG = "24px";
export const LINE_HEIGHT_XL = "36px";
export const LINE_HEIGHT_XXL = "32px";
export const LINE_HEIGHT_CUSTOM = "80px";
export const LINE_HEIGHT_CUSTOM_XL = "74px";

export const BORDER_RADIUS_NONE = "0";
export const BORDER_RADIUS_SM = "4px";
export const BORDER_RADIUS_MD = "8px";
export const BORDER_RADIUS_LG = "12px";
export const BORDER_RADIUS_XL = "16px";

export const WHITE_SPACE_NOWRAP = "nowrap";
export const TEXT_DECORATION_NONE = "none";
export const TEXT_DECORATION_UNDERLINE = "underline";

export const BACKGROUND_SIZE_COVER = "cover";
export const BACKGROUND_SIZE_CONTAIN = "contain";
export const BACKGROUND_REPEAT_NO_REPEAT = "no-repeat";
export const USER_SELECT_NONE = "none";
export const OVERFLOW_HIDDEN = "hidden";

export const BORDER_PRIMARY = "1px solid #ced1d9";
export const BORDER_SECONDARY = "1px solid #e6e6e6";